import { Seo } from "@/components/Seo";
import { ArPageHero, ArBlock, ArGrid, ArContactCTA } from "@/pages/ar/_ArShared";

export default function AboutUsAr() {
  return (
    <div data-testid="about-us-ar">
      <Seo title="عن وفا سوليوشنز" description="شركة تقنية مقرها عُمان تُشغّل منتجاتها الخاصة، والشريك التقني لمجموعة Altalib." />
      <ArPageHero
        eyebrow="عن الشركة"
        h1="عن وفا سوليوشنز"
        breadcrumbs={[{ label: "الرئيسية", to: "/ar" }, { label: "الشركة", to: "/ar/company" }, { label: "من نحن" }]}
      />

      <ArBlock tint="white" heading="شركة تقنية مقرها عُمان تُشغّل منتجاتها الخاصة">
        <div className="max-w-4xl space-y-5 text-base leading-relaxed text-wafa-ink/85 lg:text-lg">
          <p>وفا سوليوشنز LLC شركة تقنية مسجّلة في سلطنة عُمان، والشريك التقني لمجموعة Altalib. نبني برمجيات مخصصة، منتجات SaaS، تطبيقات جوال، أنظمة ذكاء اصطناعي، ومنصات حوكمة للمؤسسات هنا وفي المنطقة.</p>
          <p>معظم شركات البرمجيات تبني فقط لعملائها. نحن نفعل الأمرين معًا. منصتنا للتوصيل والخدمات اللوجستية، نظام إدارة المستودعات، منصة إدارة المعارض، و Meyar — منصتنا لحوكمة المؤسسات وحوكمة الأمن السيبراني — جميعها ملك لنا. صممناها، بنيناها، ونُشغّلها. والمزيد قيد التطوير.</p>
          <p>هذا مهم بالنسبة لكم. عندما نخبركم أن بنية معينة لن تصمد في عامها الثاني، أو أن ميزة ما ستكلف تشغيلها أكثر مما تُحقق، فذلك لأننا دفعنا تلك الفاتورة بأنفسنا.</p>
        </div>
      </ArBlock>

      <ArBlock tint="cream" heading="ما يميزنا">
        <ArGrid columns={3} items={[
          { title: "شركة مقرها عُمان", desc: "مسجّلة هنا، نعمل هنا، نبني وفق البيئة التنظيمية التي تعملون ضمنها فعليًا." },
          { title: "نبني بالذكاء الاصطناعي", desc: "هكذا يستطيع فريق صغير ومتمرس تسليم في أسابيع ما كان يحتاج فريقًا كبيرًا ونصف عام. ونوضح دائمًا أين يعمل الذكاء الاصطناعي وأين يعمل الإنسان." },
          { title: "نملك أدواتنا الجاهزة", desc: "التوصيل، المستودعات، إدارة المعارض، الحوكمة. لا تُحاسبون على إعادة بناء ما هو موجود بالفعل ويعمل." },
          { title: "نبقى", desc: "معظم عملائنا على اتفاقيات دعم بعد سنوات من الإطلاق. البناء هو بداية العلاقة." },
          { title: "نقول لا عند الحاجة", desc: "إن لم تكن مشكلتكم تحتاج برمجيات مخصصة، سنخبركم. أداة جاهزة بتكلفة 200 ريال شهريًا قد تكون الحل الأنسب أحيانًا." },
        ]} />
      </ArBlock>

      <ArBlock tint="white" heading="أين نعمل">
        <ArGrid columns={4} items={[
          { title: "عُمان", desc: "المكتب الرئيسي. تسليم المشاريع، إدارة المنتجات، والدعم." },
          { title: "الهند", desc: "الهندسة، ضمان الجودة، والعمليات التقنية." },
          { title: "الولايات المتحدة", desc: "تصميم المنتجات وهندسة الذكاء الاصطناعي." },
          { title: "الفلبين", desc: "دعم تطبيقات ممتد الساعات." },
        ]} />
        <p className="mt-6 text-sm italic text-wafa-ink/70">أربعة مواقع، ومسؤول تسليم واحد. تتحدثون دائمًا مع الشخص نفسه.</p>
      </ArBlock>

      <ArBlock tint="cream" heading="ما نؤمن به">
        <ArGrid columns={2} items={[
          { title: "البرمجيات الجيدة يجب أن تكون مملة في تشغيلها", desc: "أفضل نظام هو الذي لا يتحدث عنه أحد، لأنه ببساطة يعمل." },
          { title: "الامتثال قرار تصميم، لا مستند", desc: "ابنوه من البداية وسيكلف القليل. أضيفوه بعد تدقيق وسيكلف ثروة." },
          { title: "التقدير وعد", desc: "إن قدّرنا تكلفة، نلتزم بها. وإن تغير النطاق، ستعرفون قبل أن نبدأ العمل." },
          { title: "الفريق الصغير والمتمرس أفضل من الفريق الكبير وقليل الخبرة", desc: "لن يُسلَّم مشروعكم لمتدرب بعد اجتماع المبيعات." },
        ]} />
      </ArBlock>

      <ArContactCTA heading="جاهزون؟ احجزوا مكالمة استكشافية." />
    </div>
  );
}
